module.exports = __webpack_public_path__ + "img/features_header_finansial.f4889b93.png";